import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M16.577 20.0001L10.81 14.2341C8.65387 15.6565 5.77106 15.2165 4.13737 13.2156C2.50369 11.2148 2.64914 8.3022 4.47405 6.47407C6.30186 4.64846 9.21475 4.50238 11.216 6.13595C13.2173 7.76953 13.6576 10.6527 12.235 12.8091L18 18.5761L16.577 20.0001ZM8.03405 7.01406C6.5933 7.01315 5.35253 8.03008 5.07053 9.44297C4.78854 10.8559 5.54386 12.2712 6.87457 12.8234C8.20529 13.3756 9.74079 12.911 10.542 11.7136C11.3433 10.5162 11.1871 8.91953 10.169 7.90007C9.6043 7.33141 8.83549 7.01236 8.03405 7.01406ZM21 9.00007H15V7.00007H21V9.00007Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "SearchSmallMinus"
);
